/* eslint-disable ordered-imports/ordered-imports */
/* eslint-disable spire/fenced-imports */
/* eslint-disable camelcase */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import setView from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetView";
import { ProductListViewType } from "@insite/client-framework/Store/Pages/ProductList/ProductListState";
import { ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import CardContainerMultiColumn, {
    CardContainerMultiColumnStyles,
} from "@insite/content-library/Components/CardContainerMultiColumn";
import CardList, { CardListStyles } from "@insite/content-library/Components/CardList";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import Hidden from "@insite/mobius/Hidden";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CoveoProductListProductContext from "@NA/Components/Coveo/Contexts/CoveoProductListProductContext";
import CoveoProductListProductGridCard from "@NA/Components/Coveo/ProductCardView/CoveoProductListProductGridCard";
import CoveoProductListProductCard from "@NA/Components/Coveo/ProductListView/CoveoProductListProductCard";
import ADIPLPMarketingTile from "@NA/Components/ProductList/ADIPLPMarketingTile";
import setMyBranch from "@NA/Handlers/ADISetMyBranchHandler";
import { CategoryDetailsPageContext } from "@NA/Overrides/Pages/CategoryDetailsPage";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { CoveoProductInfo, CoveoProductModel } from "@NA/Types/CoveoModel";
import { getRealTimePricing, updateRealTimePricingForProducts } from "@NA/Utilities/CoveoUtilities";
import isMobile from "ismobilejs";
import React, { FC, ReactNode, useEffect, useRef, useState } from "react";
import { connect, ResolveThunks, useDispatch } from "react-redux";
import { css } from "styled-components";
import { customTrackPageChange, pushDataToDataLayerCoveo } from "@NA/Overrides/Common/Utilities/CustomTracking";
import useLocation from "@NA/Hooks/useLocation";
import {
    Product,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
} from "@coveo/headless/commerce";
import _ from "lodash";
import { trackSearchResultEvent } from "@insite/client-framework/Common/Utilities/tracking";
import { HasCoveoHooks, withCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";
import { isCoveoLoading } from "@NA/Utils/Coveo/CoveoUtils";
import { CoveoActions } from "@NA/Store/Reducer/CoveoCommerceReducer";
import { LoadingOverlayProps } from "@NA/MobiusOverrides/LoadingOverlay";

const enum fields {
    showImage = "showImage",
    showCompare = "showCompare",
    showBrand = "showBrand",
    showTitle = "showTitle",
    showPartNumbers = "showPartNumbers",
    showAvailability = "showAvailability",
    showAttributes = "showAttributes",
    showPrice = "showPrice",
    showAddToList = "showAddToList",
    productListDefaultView = "productListDefaultView",
}

export interface MarketingTileInterface {
    id?: string;
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showImage]: boolean;
        [fields.showCompare]: boolean;
        [fields.showTitle]: boolean;
        [fields.showBrand]: boolean;
        [fields.showPartNumbers]: boolean;
        [fields.showAvailability]: boolean;
        [fields.showAttributes]: boolean;
        [fields.showPrice]: boolean;
        [fields.showAddToList]: boolean;
        [fields.productListDefaultView]: ProductListViewType;
    };
    coveoProductInfo: CoveoProductInfo;
}

const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    return {
        isLoading: isCoveoLoading(state.ADIGlobalData.coveoCommerce),
        // TODO ISC-13448 we no need ProductListSettings DefaultView, besause we use widget property productListDefaultView instead
        view: state.pages.productList.view || ownProps.fields.productListDefaultView,
        bannerCarousal: state.ADIGlobalData.bannerCarouselStore.bannerCarousel,
        bannerIsLoading: state.ADIGlobalData.bannerCarouselStore.isLoading,
        isAuthenticated: getSession(state).isAuthenticated,
        currencyCode: getSession(state).currency?.currencyCode,
        myBranchDetails: state.ADIGlobalData.myBranchStore,
    };
};

const mapDispatchToProps = {
    setView,
    setMyBranch,
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & ResolveThunks<typeof mapDispatchToProps> & HasCoveoHooks;

export interface ProductListCardListStyles {
    wrapper?: InjectableCss;
    wrapperList?: InjectableCss;
    wrapperNoSearch?: InjectableCss;
    cardList?: CardListStyles;
    noProductsText?: TypographyPresentationProps;
    centeringWrapper?: InjectableCss;
    centeringWrapperNoSearchResults?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    cardContainerStyles?: CardContainerStyles;
    cardContainerMultiColumnStyles?: CardContainerMultiColumnStyles;
    loadingOverlay?: LoadingOverlayProps;
}

export const listStyles: ProductListCardListStyles = {
    wrapperNoSearch: {
        css: css`
            margin-top: 20px;
            @media only screen and (max-width: 700px) {
                margin-top: 0px;
            }
        `,
    },
    wrapper: {
        css: css`
            margin-top: 20px;
        `,
    },
    wrapperList: {
        css: css`
            margin: 20px 10px 0 10px;
        `,
    },
    cardList: {
        gridContainer: {
            gap: 0,
            css: css`
                width: 100%;
                @media (min-width: 375px) and (max-width: 1079px) {
                    max-width: inherit;
                }
                .card_container__wrapper {
                    margin: 0;
                }
            `,
        },
    },
    centeringWrapperNoSearchResults: {
        css: css`
            width: 100%;
            height: auto;
            display: flex;
            align-items: center;
        `,
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    noProductsText: {
        variant: "h4",
        css: css`
            display: block;
            margin: auto;
        `,
    },
    cardContainerStyles: {
        cardDivider: {
            css: css`
                width: 100%;
            `,
        },
        gridItem: {
            css: css``,
        },
    },
    loadingOverlay: {
        css: css`
            & > div:first-child[data-loading="true"] {
                position: fixed;
            }
        `,
    },
};

const styles = listStyles;
const CoveoProductListCardList: FC<Props> = ({
    isLoading,
    view,
    fields,
    setView,
    id,
    isAuthenticated,
    bannerCarousal,
    currencyCode,
    pagination,
    productList,
    summary,
    redirectionTrigger,
    didYouMean,
}) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const isSearchPage = location.isPath("/search");
    const { state: listState, methods: listMethods } = productList;
    const { state: redirectTriggerState } = redirectionTrigger;
    const { state: summaryState } = summary;
    const { state: didYouMeanState } = didYouMean;
    const { state: paginationState } = pagination;
    const isCoveoLoading = isLoading || listState?.isLoading;
    const [coveoProducts, setCoveoProducts] = useState<CoveoProductModel[]>([]);
    const [isProductRedirect, setIsProductRedirect] = useState(false);
    const [historicalPricing, setHistoricalPricing] = useState<ProductPriceDto[]>([]);
    const lastRealTimeId = useRef<string | null>(null);
    const lastResponseId = useRef<string | null>(null);

    const setLoadingRealtimePrice = (isLoading: boolean) => {
        dispatch({
            type: CoveoActions.LOAD_REALTIME_PRICING,
            isLoading,
        });
    };

     const setLoadedCompletePLP = (isLoading: boolean) => {
        dispatch({
            type: CoveoActions.COMPLETE_LOAD_PLP,
            isLoading,
        });
    };

    useEffect(() => {
        setLoadedCompletePLP(false);
    },[]);

    useEffect(() => {
        setView({ view });
    }, [view]);

    const AddRealTimePricesToProducts = async (
        currentProducts: CoveoProductModel[],
        newProducts: CoveoProductModel[],
    ) => {
        if (newProducts.length === 0) {
            return;
        }
        if (isAuthenticated) {
            setLoadingRealtimePrice(true);
            const productPricing: any = await getRealTimePricing(newProducts);
            if (productPricing === null) {
                setLoadingRealtimePrice(false);
                return;
            }
            const productsWithPrice = updateRealTimePricingForProducts(
                newProducts,
                productPricing?.realTimePricingResults as ProductPriceDto[],
            );

            // Update historical pricing
            setHistoricalPricing(prevHistoricalPricing => [...prevHistoricalPricing, ...productsWithPrice]);

            if (productsWithPrice !== undefined) {
                // Ensure all products have a price
                const updatedProducts = currentProducts.map(product => {
                    const updatedProduct =
                        productsWithPrice?.find(p => p.productId === product.productId) ||
                        historicalPricing?.find(p => p.productId === product.productId);
                    return updatedProduct || product;
                });
                setCoveoProducts(updatedProducts);
                const pageName = isSearchPage ? "Search Results" : "Product List Page";
                pushDataToDataLayerCoveo(updatedProducts, pageName, isAuthenticated, currencyCode as string);
            }
            setLoadingRealtimePrice(false);
        }
    };

    const convertProductArrToCoveoProductModelArr = (products: Product[]): CoveoProductModel[] => {
        return (
            products.map(_product => {
                const product = _.cloneDeep(_product);
                const responseId = listState?.responseId || "";
                const productId = product?.ec_product_id;
                // Check if product already exists in the hold list
                const ec_erp_number: any = product.additionalFields?.ec_erp_number;
                const erp_number = ec_erp_number ? ec_erp_number[0] : "";
                const groupId: any = product.additionalFields?.ec_item_group_id;

                const variantTypeId = groupId && !groupId.includes(productId) ? productId : null;
                const minimumOrderQty = product.additionalFields?.ec_minimum_qty;
                product.ec_price = product.ec_price || 0;
                const interactiveProduct = listMethods?.interactiveProduct({ options: { product } });
                return {
                    title: product.ec_name,
                    brandName: product.ec_brand,
                    category: product.ec_category,
                    shortDescription: product.ec_shortdesc,
                    productNumber: erp_number,
                    manufacturerItem: product.additionalFields?.ec_manufacturer_item,
                    availability: product.additionalFields?.ec_availability,
                    urlSegment: product.additionalFields?.ec_product_url_segment,
                    imageAltText: product.additionalFields?.imagealttext,
                    mediumImagePath: product.additionalFields?.mediumimagepath,
                    smallImagePath: product.additionalFields?.smallimagepath,
                    variantTypeId,
                    canAddToCart: false,
                    quoteRequired: product.additionalFields?.quoteRequired,
                    minimumOrderQty: minimumOrderQty === "0" ? "1" : minimumOrderQty,
                    allowZeroPricing: product.additionalFields?.ec_allow_zero_pricing,
                    unitListPrice: product.additionalFields?.ec_unit_list_price,
                    vendorAuthRequiredList: product.additionalFields?.ec_vendor_auth_required_list,
                    vendorAuthRequiredLink: product.additionalFields?.ec_vendor_auth_required_link,
                    unitofmeasure: product.additionalFields?.ec_unit_measure,
                    productId,
                    canonicalUrl: product.additionalFields?.ec_canonical_url,
                    pricing: null,
                    featureBullets1to3: product.additionalFields?.ec_featurebullets1to3,
                    classificatioN_CODE: product.additionalFields?.ec_classification_code,
                    saleType: product.additionalFields?.ec_saletype,
                    onSaleNow: product.additionalFields?.ec_onsalenow,
                    brandUrlSegment: product.additionalFields?.ec_brand_url_segment,
                    isNewProduct: product.additionalFields?.ec_isnewproduct,
                    showAuthorizationRequired: false,
                    responseId,
                    position: product.position,
                    modelNumber: product.additionalFields?.ec_model_number,
                    logicBroker: product.additionalFields?.ec_logicbroker,
                    interactiveProduct,
                } as CoveoProductModel;
            }) || []
        );
    };

    const removeBatches = <T,>(arr: T[], batchSize: number): T[] => {
        while (arr.length > batchSize) {
            // console.log("Removing Batch >>", arr.slice(0, batchSize));
            arr.splice(0, batchSize);
        }
        return arr;
    };

    useEffect(() => {
        if (isCoveoLoading || !listState?.products) return;

        const products = listState?.products;
        if (products.length === 0) {
            setCoveoProducts([]);
            return;
        }

        if (isSearchPage) {
            const originalQuery = encodeURIComponent(summaryState?.query || "");
            const correctedQuery = didYouMeanState?.queryCorrection.correctedQuery;
            const totalCount = paginationState?.totalEntries;
            trackSearchResultEvent(originalQuery, Number(totalCount) | 0, correctedQuery);
        }

        const convertedAllProducts = convertProductArrToCoveoProductModelArr(products);
        setCoveoProducts(convertedAllProducts);

        if (isAuthenticated) {
            const productsFiltered = products.length <= 28 ? products : removeBatches([...products], 28);
            const convertedFilteredProducts = convertProductArrToCoveoProductModelArr(productsFiltered);

            const currentResponseId = listState?.responseId || "";
            if (currentResponseId !== lastRealTimeId.current) {
                AddRealTimePricesToProducts(convertedAllProducts, convertedFilteredProducts);
                lastRealTimeId.current = currentResponseId;
            }
        } else {
            const pageName = isSearchPage ? "Search Results" : "Product List Page";
            pushDataToDataLayerCoveo(convertedAllProducts, pageName, isAuthenticated, currencyCode as string);
        }
    }, [isCoveoLoading, listState?.products]);

    // Redirect to product page if only one product is found && it matches the query as ERP number
    useEffect(() => {
        if (!isSearchPage || isCoveoLoading || !listState?.products) return;

        if (listState.products.length === 1) {
            const product = listState.products[0];
            const {
                additionalFields: { ec_erp_number, ec_canonical_url },
            } = product;
            const query = summaryState?.query.trim().toLowerCase() || "";
            const hasNoQuery = query === "";
            if (hasNoQuery || !String(ec_erp_number).toLocaleLowerCase().includes(query) || query === ec_erp_number) {
                return;
            }

            const productUrl = String(ec_canonical_url).trim();
            // console.log('productUrl >>', productUrl);
            if (productUrl !== "") {
                setIsProductRedirect(true);
                window.location.replace(productUrl);
            }
        }
    }, [isCoveoLoading, listState?.products]);

    // If there are no results after loading, redirect to no-results page
    useEffect(() => {
        if (isCoveoLoading || !listState?.products) return;

        const responseIdChanged = listState?.responseId && listState?.responseId !== lastResponseId.current;
        const hasZeroResults = listState?.products?.length === 0;

        if (responseIdChanged && hasZeroResults && !isCoveoLoading) {
            const lastQuery = summaryState?.query || "";
            if (isSearchPage && lastQuery === "") return;

            const autoCorrect = didYouMeanState?.queryCorrection.correctedQuery;
            const lastUrl = location.pathname + location.search;
            const redirectUrl = isSearchPage
                ? `/no-results?last_query=${lastQuery}${
                    autoCorrect ? `&did_you_mean=${encodeURIComponent(autoCorrect)}` : ""
                }`
                : `/no-results?last_url=${lastUrl}`;

            setIsProductRedirect(true);
            window.location.replace(redirectUrl);
        }
        lastResponseId.current = listState?.responseId;
    }, [isCoveoLoading, listState?.products]);

    // Has redirect, redirect to page
    useEffect(() => {
        if (!isSearchPage || !redirectionTrigger.state?.redirectTo) {
            return;
        }

        setIsProductRedirect(true);
        window.location.replace(redirectionTrigger.state.redirectTo);
    }, [redirectionTrigger.state]);

    const hasRedirectTrigger = redirectTriggerState?.redirectTo;
    const isEmptyServer = IS_SERVER_SIDE && listState?.products?.length === 0;
    const isEmptyClient = !IS_SERVER_SIDE && coveoProducts.length === 0;
    const hasNoProductsAfterLoading = !isCoveoLoading && (isEmptyServer || isEmptyClient);
    if (hasRedirectTrigger || isProductRedirect || hasNoProductsAfterLoading) {
        return <></>;
    }

    const renderProducts = (children: ReactNode) => {
        const products = IS_SERVER_SIDE
            ? convertProductArrToCoveoProductModelArr(listState?.products || [])
            : coveoProducts.length > 0
            ? coveoProducts
            : [];

        if (products.length === 0) return null;
        // setting state for completly loaded PLP         
        setLoadedCompletePLP(true);
        if (bannerCarousal?.marketingTileList.length && view === "Grid") {
            const copiedProducts = [...products];
            copiedProducts.splice(4, 0, { productId: "marketingTile" } as unknown as CoveoProductModel);
            return copiedProducts.map((product, idx) => {
                if (product.productId === "marketingTile" && !isMobile().any) {  
                    return (
                        <CardContainerMultiColumn key={idx} extendedStyles={styles.cardContainerMultiColumnStyles}>
                            <ADIPLPMarketingTile marketingTile={bannerCarousal.marketingTileList[0]} />
                        </CardContainerMultiColumn>
                    );
                }

                return (
                    <CoveoProductListProductContext coveoProduct={product} idx={idx} key={idx + product.productId}>
                        {children}
                    </CoveoProductListProductContext>
                );
            });
        }
        return products.map((product: CoveoProductModel, idx: number | undefined) => (
            <CoveoProductListProductContext coveoProduct={product} idx={idx} key={idx + product.productId}>
                {children}
            </CoveoProductListProductContext>
        ));
    };

    const overriddenProps = { ...fields };

    if (getIsWebCrawler()) {
        overriddenProps.showAvailability = false;
    }

    if (isSearchPage) {
        customTrackPageChange();
    }

    return (
        <StyledWrapper {...(view === "List" ? styles.wrapperList : styles.wrapper)}>
            <LoadingOverlay loading={isCoveoLoading} {...styles.loadingOverlay}>
                <Hidden below="md">
                    <CardList extendedStyles={styles.cardList} data-test-selector={`productListCardContainer${view}`}>
                        {view === "Table" ? (
                            <div>table</div>
                        ) : (
                            renderProducts(
                                view === "List" ? (
                                    <CardContainer extendedStyles={styles.cardContainerStyles}>
                                        <CoveoProductListProductCard {...overriddenProps} />
                                    </CardContainer>
                                ) : (
                                    <CardContainerMultiColumn extendedStyles={styles.cardContainerMultiColumnStyles}>
                                        <CoveoProductListProductGridCard {...overriddenProps} />
                                    </CardContainerMultiColumn>
                                ),
                            )
                        )}
                    </CardList>
                </Hidden>
                <Hidden above="sm">
                    <CardList extendedStyles={styles.cardList} data-test-selector="cardListProductsNarrow">
                        {renderProducts(
                            <CardContainer extendedStyles={styles.cardContainerStyles}>
                                <CoveoProductListProductCard {...overriddenProps} />
                            </CardContainer>,
                        )}
                    </CardList>
                </Hidden>
            </LoadingOverlay>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCoveoHooks(CoveoProductListCardList)),
    definition: {
        group: "Product List",
        displayName: "Coveo Card List",
        allowedContexts: [ProductListPageContext, CategoryDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.showImage,
                displayName: "Show Image",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.showCompare,
                displayName: "Show Compare",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 2,
            },
            {
                name: fields.showBrand,
                displayName: "Show Brand",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.showTitle,
                displayName: "Show Title",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 4,
            },
            {
                name: fields.showPartNumbers,
                displayName: "Show Part Numbers",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 5,
            },
            {
                name: fields.showAvailability,
                displayName: "Show Availability",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 6,
            },
            {
                name: fields.showAttributes,
                displayName: "Show Attributes",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 7,
            },
            {
                name: fields.showPrice,
                displayName: "Show Price",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 8,
            },
            {
                name: fields.showAddToList,
                displayName: "Show Add To List",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                sortOrder: 9,
            },
            {
                name: fields.productListDefaultView,
                editorTemplate: "RadioButtonsField",
                defaultValue: "List",
                fieldType: "General",
                sortOrder: 10,
                options: [
                    {
                        displayName: "List",
                        value: "List",
                    },
                    {
                        displayName: "Grid",
                        value: "Grid",
                    },
                    {
                        displayName: "Table",
                        value: "Table",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
